import "@babel/polyfill";
import "./aj/polyfill.web";
import main from "./web/main";
    
main();